<template lang="pug">
	#gallery
		h2.section-title Galeria
		.content
			.images
				.wrap-image(v-for="(image, i) in images",)
					img.image(:src="image", @click="index = i")
			vue-gallery-slideshow(:images="images", :index="index", @close="index = null")
</template>

<script>
import VueGallerySlideshow from 'vue-gallery-slideshow'

export default {
	name: 'Gallery',
	components: { VueGallerySlideshow },
	data: () => ({
		images: [
			require("@/assets/images/photos/foto1.jpeg"),
			require("@/assets/images/photos/foto2.jpeg"),
			require("@/assets/images/photos/foto3.jpeg"),
			require("@/assets/images/photos/foto4.jpeg"),
			require("@/assets/images/photos/foto5.jpeg"),
			require("@/assets/images/photos/foto6.jpeg"),
			require("@/assets/images/photos/foto7.jpeg"),
			require("@/assets/images/photos/foto8.jpeg"),
			require("@/assets/images/photos/foto9.jpeg"),
			require("@/assets/images/photos/foto10.jpeg"),
			require("@/assets/images/photos/foto11.jpeg"),
			require("@/assets/images/photos/foto12.jpeg"),
		],
		index: null
	}),
}
</script>

<style lang="stylus">
@import '../assets/css/resources'

#gallery
	float left
	width 100%
	display flex
	flex-direction column
	background-color white

	.content
		width 1366px
		flex 1
		display flex
		flex-direction column
		justify-content center
		margin 50px auto 20px

		.images
			width 100%
			display flex
			flex-wrap wrap

			.wrap-image
				position relative
				float left
				width 25%
				height 220px
				padding 15px
				box-sizing border-box

				.image
					cursor pointer
					width 100%
					height 100%
					border-radius 6px
					object-fit cover
					object-position center

				&:after
					content ''
					pointer-events none
					position absolute
					top 15px
					left 15px
					width calc(100% - 30px)
					height calc(100% - 30px)
					border-radius 6px
					background-color rgba(black, 0.5)
					opacity 0
					transition opacity .25s ease

				&:hover
					&:after
						opacity 1

@media (max-width: 1366px)
	#gallery
		.content
			width 100%
			.images
				.wrap-image
					width 33.33%
					height 300px

@media (max-width: 720px)
	#gallery
		.content
			width 100%
			.images
				.wrap-image
					width 50%
					height 200px

@media (max-width: 480px)
	#gallery
		.content
			width 100%
			.images
				.wrap-image
					width 50%
					height 150px
</style>



// WEBPACK FOOTER //
// src/components/Gallery.vue